import clsx from 'clsx';
import * as React from 'react';

import type { CustomizationContentLink } from '@gitbook/api-client';

import { ContentRefPreview } from './ContentRefPreview';

export function CustomizationContentLinkItem(props: {
    contentLink: CustomizationContentLink;
    className?: string;
}) {
    return (
        <div className={clsx('flex flex-col gap-0.5', props.className)}>
            <div className="truncate">{props.contentLink.title}</div>
            <div className="truncate text-muted text-ui-small">
                <React.Suspense fallback={<span aria-busy>Loading...</span>}>
                    <ContentRefPreview contentRef={props.contentLink.to} />
                </React.Suspense>
            </div>
        </div>
    );
}
